import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const MapsLocationIcon = ({ className }: IProps) => {
  const iconClassName = classNames('radius-icon', className);

  return (
    <svg className={iconClassName} width='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4987 10.3125C14.0875 10.3125 12.1445 12.285 12.1445 14.7037C12.1445 16.0959 12.7078 17.185 13.7511 18.1095C14.3801 18.667 15.4952 19.8413 15.9117 20.5245C16.0345 20.726 16.252 20.8504 16.4879 20.8541C16.7238 20.8578 16.9451 20.7403 17.0742 20.5428C17.5242 19.8541 18.6296 18.6561 19.2463 18.1095C20.2896 17.185 20.8529 16.0959 20.8529 14.7037C20.8529 12.285 18.9099 10.3125 16.4987 10.3125ZM16.4905 12.8333C15.4825 12.8333 14.6654 13.6541 14.6654 14.6667C14.6654 15.6792 15.4825 16.5 16.4905 16.5H16.5069C17.5149 16.5 18.332 15.6792 18.332 14.6667C18.332 13.6541 17.5149 12.8333 16.5069 12.8333H16.4905Z'
        fill='currentColor'
      />
      <path
        d='M12.0897 18.3695L8.01953 16.6223L8.01953 1.146L13.0612 3.30964V10.0899C11.6663 11.1453 10.7695 12.8254 10.7695 14.7038C10.7695 16.1535 11.2506 17.3606 12.0897 18.3695Z'
        fill='currentColor'
      />
      <path
        d='M20.8529 10.9565V4.35281C20.8529 3.97312 20.5451 3.66531 20.1654 3.66531H14.4362V9.32187C15.075 9.07387 15.7701 8.93766 16.4987 8.93766C18.2486 8.93766 19.8054 9.7234 20.8529 10.9565Z'
        fill='currentColor'
      />
      <path
        d='M1.51839 3.81708L6.64453 1.1891L6.64453 16.5405L2.04906 18.0694C1.83943 18.1391 1.60906 18.1038 1.42988 17.9746C1.2507 17.8454 1.14453 17.6379 1.14453 17.417V4.42887C1.14453 4.17095 1.28888 3.93474 1.51839 3.81708Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default MapsLocationIcon;
